import React from 'react'
import SkillsLivelihood from"../../Images/OurWork/Skills-livelihood.png"
const LivelihoodSkilling = () => {
  return (
     <div>
            <img src={SkillsLivelihood} />
          </div>
  )
}

export default LivelihoodSkilling
